import Appointment2 from '@/components/Appointment2';
import Banner from '@/components/Banner2';
import Features from '@/components/Features';
import { FEATURES_LIST } from './index.js';
import Function from './components/Function';
import Scene from './components/Scene';
import Cases from './components/Cases';
export default {
  components: {
    Banner,
    Features,
    Appointment2,
    Function,
    Scene,
    Cases
  },
  data() {
    return {
      featuresList: FEATURES_LIST,
      productId: this.$productId.ZHI_NENG_TOU_YAN.ZHI_NENG_TOU_YAN
    };
  }
};